var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"no-data-text":"Danh sách trống","return-object":"","item-text":"label","items":_vm.academicLevels,"item-value":"id","clearable":"","loading":_vm.loading,"multiple":_vm.multiple},on:{"change":_vm.onChange,"input":function($event){return _vm.$emit('input', $event)}}},'v-autocomplete',this.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }